import { PatientModel } from './../../../models/consultation/patient.model';

import { Component, OnInit, Inject, ViewChild, group } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';

import { FormGroup, FormBuilder, Validators, SelectControlValueAccessor } from '@angular/forms';
import { Utility } from '../../../common/utility';
import { BaseService } from '../../../shared/services/base.service';
import { FormLabelComponent } from '../../../components/form/label/label.component';
import { FormMessageComponent } from '../../../components/form/message/message.component';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';

import { ManagePatientAccountService } from './manage-patient.service';
import { ManageUserPatientModel } from '../../../models/centre/manage-user-patient.model';
import { DialogService } from '../../../shared/services/dialog.service';
import { PatientWarningService } from '../../../components/dialog/patient-warning.service';
import { UserUrl } from '../../../shared/urls/user.url';
import { PatientInformationFormComponent } from './patient-information-form.component';
import { ValidationService } from '../../../shared/services/validation.service';
import { UserType } from '../../../shared/constants/permission';
import { Router } from '@angular/router';
import { SelectClinicPopupComponent } from '../../select-clinic/select-clinic-popup.component';

@Component({
    selector: 'modify-patient-popup',
    templateUrl: 'modify-patient-popup.component.html',
    providers: [ManagePatientAccountService, PatientWarningService]
})

export class ModifyPatientPopupComponent implements OnInit {
    @ViewChild('patient') patientChild;
    public title: string;
    public isModifySuccess = false;
    public edit = false;
    private isFromWaitingRoom = false;
    public partyTypeEnum;
    // public tempEmail = '';
    constructor(
        private router: Router,
        private formBuilder: FormBuilder,
        private baseService: BaseService,
        public utility: Utility,
        private managePatientService: ManagePatientAccountService,
        public dialogRef: MdDialogRef<ModifyPatientPopupComponent>,
        public clinicDialogRef: MdDialogRef<SelectClinicPopupComponent>,
        public dialogService: DialogService,
        public patientWarningService: PatientWarningService,
        @Inject(MD_DIALOG_DATA) public data: any) { }

    ngOnInit() {
        if (this.data.id) {
            this.edit = this.data.edit;
            this.patientChild.isEdit = true;
            this.title = 'Update Patient Account'; 1
            this.patientChild.patientInformationForm.controls['userName'].disable();
            this.managePatientService.getPatientUser(this.data.id).subscribe(
                (result) => {
                    if (result) {
                        const data = result.json();
                        this.patientChild.patientModel = data;
                        this.patientChild.patientInformationForm.controls['birthDay'].setValue(new Date(data['dateOfBirth']));
                        this.patientChild.patientInformationForm.controls['dateOfBirth'].setValue(data['dateOfBirth']);

                        if (data['isSeparateBillingAddress'] === true) {
                            this.patientChild.isSeparate = true;
                        }
                        if (data['partyTypeId'].value === '1') {
                            this.patientChild.isGroup = true;
                            ValidationService.attachRequired(this.patientChild.patientInformationForm.controls['partyId'], []);
                        }

                        this.patientChild.patientModel.isEnableCreateMyTMBAccount = data.isEnableCreateMyTMBAccount;
                        this.patientChild.patientModel.isCreateMyTMBAccount = data.isCreateMyTMBAccount;
                        this.patientChild.patientInformationForm.controls['isCreateMyTMBAccount'].setValue(new Boolean(data.isCreateMyTMBAccount));

                        if (this.patientChild.patientInformationForm.controls['isCreateMyTMBAccount'].value === true
                            || (this.patientChild.patientModel != null && this.patientChild.patientModel.isCreateMyTMBAccount == true
                                || data.isCreateMyTMBAccount == false)) {
                            ValidationService.attachRequired(this.patientChild.patientInformationForm.controls['email'],
                                [Validators.required, ValidationService.isValidEmail]);

                            if(this.patientChild.patientInformationForm.controls['userName'].value + '' != '')
                                this.patientChild.patientInformationForm.controls['isCreateMyTMBAccount'].disable();

                        } else {
                            ValidationService.removeRequired(this.patientChild.patientInformationForm.controls['email'], [ValidationService.isValidEmail]);
                        }
                    }
                }
            );

        } else {
            if (this.data.isFromWaitingRoom) {
                this.isFromWaitingRoom = this.data.isFromWaitingRoom;
            }
            this.patientChild.isHidden = true;
            this.title = 'Add Patient Account';
            console.log(this.patientChild);
            this.patientInit();
        }
        this.partyTypeEnum = this.patientChild['partyTypeEnum'];
    }

    patientInit() {
        this.patientChild.isAdd = true;
        this.patientChild.patientInformationForm.enable();
    }

    onCloseDialog() {
        this.dialogRef.close(this.isModifySuccess);
    }

    updatePatient() {
        this.managePatientService.updatePatientAccount(this.data.id, this.patientChild.patientInformationForm.value).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.dialogService.openSuccessDialog({ message: data.message });
                    // update success flag to reload page
                    this.isModifySuccess = true;
                    this.onCloseDialog();
                }
            });
    }

    editPatient() {
        this.updatePatient();
    }

    addPatient(clinicId) {
        this.managePatientService.addPatientAccount(this.patientChild.patientInformationForm.value, clinicId).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.isModifySuccess = true;

                    if (this.patientChild.patientInformationForm.controls['partyTypeId'].value.toString() == this.partyTypeEnum.Family.toString()) {
                        this.resetForm(this.patientChild.patientInformationForm);
                    }
                    else {
                        this.onCloseDialog();
                    }
                    var msg = data.message;
                    var patientRef = data.ref;
                    if (msg.includes("has been existed")) {
                        this.patientWarningService.openDialog({ message: data.message });
                    }
                    else {
                        this.dialogService.openSuccessDialog({
                            message: data.message,
                            patientRef: patientRef
                        });
                    }
                }
            });
    }

    onSubmit() {

        // call submit from patientChild to validate form
        this.patientChild.ngForm.onSubmit();

        if (this.patientChild.patientInformationForm.controls['partyTypeId'].value === 'Individual') {
            this.patientChild.patientInformationForm.controls['partyId'].setValue('');
        }
        this.markAsTouch(this.patientChild.patientInformationForm);

        // submit form
        if (this.patientChild.patientInformationForm.valid) {
            // set time stamp
            this.patientChild.patientInformationForm.controls['dateOfBirth'].setValue(
                this.utility.convertDateToString(this.patientChild.patientInformationForm.controls['birthDay'].value));
            var firstname = this.patientChild.patientInformationForm.controls['firstName'].value.trim();
            var surname = this.patientChild.patientInformationForm.controls['surName'].value.trim();
            var middlename = this.patientChild.patientInformationForm.controls['middleName'].value;
            var isEnableCreateMyTMBAccount = this.patientChild.patientInformationForm.controls['isCreateMyTMBAccount'].value;
            if (middlename != null && middlename !== undefined) {
                middlename = middlename.trim();
            }
            //firstname = firstname.replace(/\s/g, '');
            //surname = surname.replace(/\s/g, '');
            this.patientChild.patientInformationForm.controls['surName'].setValue(surname);
            this.patientChild.patientInformationForm.controls['firstName'].setValue(firstname);
            this.patientChild.patientInformationForm.controls['middleName'].setValue(middlename);
            this.patientChild.patientInformationForm.controls['isEnableCreateMyTMBAccount'].setValue(isEnableCreateMyTMBAccount);


            var email = this.patientChild.patientInformationForm.controls['email'].value;
            if (this.patientChild.patientInformationForm.controls['isCreateMyTMBAccount'].value === true && email !== undefined && email !== "") {
                const confirmMessage = AppMessages.patient.addSameEmail;

                const param = {
                    emailAddress: email,
                    patientId: this.data.id
                };
                this.managePatientService.checkEmailExists(param).subscribe(
                    (c) => {
                        if (c) {
                            const emailData = c.json();
                            // TODO: check
                            if (emailData != null && (this.data.id != emailData.id)) {
                                this.dialogService.openConfirmationDialog({ message: confirmMessage }).subscribe(result => {
                                    if (result) {
                                        if (this.data.id) {
                                            this.editPatient();
                                        } else {
                                            this.dialogService.openComponentDialog(SelectClinicPopupComponent).subscribe(r => {
                                                // user select clinic  result = clinicId
                                                if (r.isSuccess) {
                                                    const clinicId = r.id;
                                                    this.addPatient(clinicId);
                                                }
                                            });
                                        }
                                    }
                                });
                            }
                            else {
                                if (this.data.id) {
                                    this.editPatient();
                                } else {
                                    this.dialogService.openComponentDialog(SelectClinicPopupComponent).subscribe(r => {
                                        // user select clinic  result = clinicId
                                        if (r.isSuccess) {
                                            const clinicId = r.id;
                                            this.addPatient(clinicId);
                                        }
                                    });
                                }
                            }
                        }
                    });
            }
            else {
                if (this.data.id) {
                    this.editPatient();
                }
                else {
                    this.dialogService.openComponentDialog(SelectClinicPopupComponent).subscribe(r => {
                        // user select clinic  result = clinicId
                        if (r.isSuccess) {
                            const clinicId = r.id;
                            this.addPatient(clinicId);
                        }
                    });
                }
            }

        }
    }

    checkEmailExist(emailAddress) {

    }
    markAsTouch(groupControl: FormGroup) {
        for (const key in groupControl.controls) {
            if (groupControl.controls.hasOwnProperty(key)) {
                groupControl.controls[key].markAsTouched();
                groupControl.controls[key].updateValueAndValidity();
            }
        }
    }

    resetForm(groupControl: FormGroup) {
        for (const key in groupControl.controls) {
            if (groupControl.controls.hasOwnProperty(key)) {
                switch (key.toLowerCase()) {
                    case 'patientref':
                        groupControl.controls[key].setValue('N/A');
                        break;
                    case 'isincludeinmarketing': case 'isseparatebillingaddress':
                    case 'isdeceased': case 'isactive': case 'isdisable':
                        groupControl.controls[key].setValue(false);
                        break;
                    case 'callbackurl': case 'surname': case 'homephone': case 'workphone': case 'countryid':
                    case 'countryofbirthid': case 'address1': case 'address2': case 'address3':
                    case 'postcode': case 'healthinsuranceid': case 'healthpolicynumber': case 'marketingid': case 'iscreatemytmbaccount':
                    case 'mobilephone': case 'email': case 'partytypeid':
                        break;
                    case 'ismanuallyactive': case 'sendactivationemail':
                        groupControl.controls[key].setValue(false);
                        groupControl.controls[key].markAsPristine();
                        groupControl.controls[key].markAsUntouched();
                        groupControl.controls[key].setErrors(null);
                        break;
                    default:
                        groupControl.controls[key].reset();
                        groupControl.controls[key].markAsPristine();
                        groupControl.controls[key].markAsUntouched();
                        groupControl.controls[key].setErrors(null);
                        break;
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-patient-user/modify-patient-popup.component.ts